import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "../PurchaseInvoices.css";
import toast from "react-hot-toast";
import {
    refreshPage,
    toastStyle,
} from "../../../../Helpers/Utils/Common";
import {
    Col,
    Form,
} from "react-bootstrap";
import { closeOverpaidBill } from "../../../../Helpers/apiCalls/Purchases/purchaseInvoiceApi";
import { closeOverpaidBillPotato } from "../../../../Helpers/apiCalls/PotatoCorner/Purchases/purchaseInvoiceApi";

export default function CloseBillModal(props) {
    
const [remarks, setRemarks] = useState("");
    
async function CloseBill() {
    const response = await closeOverpaidBill(props.selectedRow.id, remarks);
    if (response.data) {
        toast.success("Successfully closed overpaid bill!", {
            style: toastStyle(),
        });
        refreshPage()
    } else if (response.error) {
        toast.error(
            "Something went wrong",
            { style: toastStyle() }
        );
        // setTimeout(() => refreshPage(), 1000);
    }
}

    return (
        <div>
            <Modal show={props.show} onHide={props.hide} size="lg" centered>
                <Modal.Header className="return-header">
                    <span className="text-warning"> PLEASE CONFIRM </span>
                </Modal.Header>
                <Modal.Body className="return-body text-center">
                    <span>Are you sure you want to {props.type} overpaid bill?</span>
                    {props.type === "close" && (
                        <Col className="text-left pt-3">
                        <span>REMARKS</span>
                        <Form.Control
                            as="textarea"
                            name="remarks"
                            defaultValue={props.selectedRow.remarks}
                            className="nc-modal-custom-row-grey"
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                        
                    </Col>
                    )}
                    <div className="d-flex justify-content-end my-4 d-flex-responsive">
                    <button type="button" className={props.type === "delete" || props.type === "reject" ? "button-warning me-3" : "button-secondary me-3"} onClick={props.hide}>Cancel</button>
                    <button type="button" className={props.type === "delete" || props.type === "reject" ? "button-warning-fill" : "button-primary"} onClick={CloseBill}>Proceed</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}